import PropTypes from 'prop-types'

import './index.scss'

const Content = ({ children, className }: any) => <div className={`card__content ${className}`}>{children}</div>

Content.displayName = 'Content'

Content.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string
}

Content.defaultProps = {
  children: null,
  className: ''
}

export default Content
